export const defaultTheme = {
  'color-primary': '#f97316',
  'color-primary-hover': '#fb923c',
  'color-bg': '#fffaf5',
  'color-text': '#1f2937',
  'color-border': '#fed7aa',
  'font-family': "'Inter', -apple-system, sans-serif",
  'border-radius': '6px',
  'spacing-xs': '4px',
  'spacing-sm': '8px',
  'spacing-md': '16px',
  'spacing-lg': '24px',
  'spacing-xl': '32px',
};
